module.exports = __webpack_public_path__ + "23b3065d35072cdc4c8d1325005b3ab2.svg";